import type { ReactNode } from "react";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  icon?: string;
  action?: ReactNode;
}

export default function SectionHeading({ title, subtitle, icon, action }: SectionHeadingProps) {
  return (
    <div className="mb-5 flex items-end justify-between gap-4">
      <div>
        <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          {icon && (
            <span className="flex h-7 w-7 items-center justify-center rounded-md bg-primary-100 text-primary-600">
              <i className={`${icon} text-base`} />
            </span>
          )}
          {title}
        </h2>
        {subtitle && <p className="mt-1 text-sm text-foreground-500">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}